import useAppToast from '@/hooks/useAppToast';
import { getRezeptSheetDetail } from '@/services/admin/rezeptSheetService';
import { getApiErrorMessage, DEFAULT_CONFLICT_ERROR_MESSAGE } from '@/utils/apiError';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Fetches a single rezept sheet detail for admin edit modal.
 */
export const useAdminRezeptSheetDetail = (id: number | null) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const toast = useAppToast();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['rezept-sheet', 'detail', currentSite, id],
    queryFn: () => getRezeptSheetDetail(currentSite, id!),
    enabled: !!currentSite && id != null,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(getApiErrorMessage(error, DEFAULT_CONFLICT_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  return { data, isLoading, isError };
};
